//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('textileModelCategory4s', {
//        templateUrl: 'views/components/views/textileModelCategory4s/textileModelCategory4s.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'textileModelCategory4sService', function (stateService, textileModelCategory4sService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListCategories4: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadTextileModelCategory4s() {
//                vm.model.itemsListCategories4 = await textileModelCategory4sService.listTextileModelCategory4s();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'textilemodelcategory4':
//                        go({ textilemodelcategory4_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadTextileModelCategory4s();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
